import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config, ILanguage } from '@other/interfaces';
import { CognosService } from './cognos.service';
import { Store } from '@ngxs/store';
import { ConfigActions } from '@store/config.state';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { getJsonFromUrl } from '@other/functions';
import { LogService } from "@services/log.service";

@Injectable()
export class ConfigService {
  private logger: LogService;

  constructor(
    private http: HttpClient,
    private cognos: CognosService,
    private _store: Store,
    private _logger: LogService
  ) {
    (window as any).config = this;
    this.logger = _logger;
  }

  config: Config;

  load(): Promise<void> {
    this.logger.info("load","Promise ConfigService")
    this.logger.info("load","Promise ConfigService")
    return new Promise(resolve => {
      this.logger.info("load","ConfigService", "Promise: "+location.hostname)
      this.logger.info("load","ConfigService", "Promise: "+location.hostname)
      const corpintra = location.hostname.indexOf('intra.net') > -1;
      let configFile = corpintra ? 'config_daimler.json' : 'config.json';
      // Let the developer / user give a custom config
      const customConfig = localStorage.getItem('co_configfile');
      if (customConfig) {
        this.logger.info("load","ConfigService", "customConfig: "+customConfig)
        this.logger.info("load","ConfigService", "customConfig: "+customConfig)
        configFile = customConfig
      } else {
        this.logger.info("load","ConfigService", "No custom config set in localStorage. Use co_configfile to set it. Using default: "+configFile)
      }
      forkJoin([
        this.http.get<Config>('assets/config_common.json'),
        this.http.get<Config>('assets/' + configFile)
      ]).pipe(
        // Merge common config with custom
        map(([common, config]) => ({ ...common, ...config }))
      ).subscribe(config => {
        (window as any).config = config;
        const search: any = getJsonFromUrl();
        // Set variable parameters from search or localStorage
        config.target = search.target ? search.target : config.target;
        config.debug = search.debug ? search.debug === 'true' : config.debug;
        search.delay = search.delay ? search.delay * 1000 : 0;
        config.language = localStorage.getItem('lang') as ILanguage || config.language;
        config.corpintra = config.corpintra;
        // Check delay is at least 1 second ... so that people think we are loading data
        config.delay = config.delay < 1000 ? 1000 : config.delay;

        // Set config object in service and state
        // Please use ConfigState in future code instead of service
        this.config = config as Config;
        this._store.dispatch( new ConfigActions.Set({ ...this.config }) );
        this.logger.info("load","ConfigService", "corpintra:"+this.config.corpintra)
        if (this.config.corpintra || localStorage.getItem("co_corpintra") == "true") {
          // Initialize login process
          this.logger.info("load","ConfigService", "Initialize login process")
          // Assuming this is in your config.service.ts file
          this.cognos.load({ ...config }, () => {
            // Code to execute after loading is complete
            this.logger.info("load","ConfigService", "Login process completed!");
          });
        } else {
          // Show App
          this.logger.info("load","ConfigService", "Show App")
        }
        // Generate delay to make user feel we are loading data
        this.logger.info("load","ConfigService", "Generate delay to make user feel we are loading data "+search.delay +" : " + config.delay)
        setTimeout(() => resolve(), search.delay || config.delay);
        
      });
    });
  }
}